import { Reducer } from 'redux';
import { SET_USERID, SdkTypes, SET_DISPLAY_NAME , SET_USER_TOKEN, SET_FULL_NAME } from '../actions/sdk';

export interface SdkState {
  userId?: string;
  userToken?: string;
  displayName: string;
  fullName?:string;
}

const initialState: SdkState = {
  displayName: ''
};

export const sdkReducer: Reducer<SdkState, SdkTypes> = (state = initialState, action: SdkTypes): SdkState => {
  switch (action.type) {
    case SET_USERID:
      return { ...state, userId: action.userId };
    case SET_USER_TOKEN:
        return { ...state, userToken: action.userToken};
    case SET_DISPLAY_NAME:
      return { ...state, displayName: action.displayName };
    case SET_FULL_NAME:
        return { ...state, fullName: action.fullName};
    default:
      return state;
  }
};
